export default {
	shopList: {
		item_count:0,
		list:[],
		total_count:0
	},
	list: [],
	itemList: []
}



// WEBPACK FOOTER //
// ./src/store/mp/shops/shop_manage/state.js